// ** MUI Imports
import { Theme } from '@mui/material/styles'
import { lighten, darken } from '@mui/material/styles'

const Alert = (theme: Theme) => {
  const getColor = theme.palette.mode === 'light' ? darken : lighten

  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 5,
          '& .MuiAlertTitle-root': {
            marginBottom: theme.spacing(1.6)
          },
          '& a': {
            fontWeight: 500,
            color: 'inherit'
          }
        },
        standardSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.light,
          '& .MuiAlertTitle-root': {
            color: theme.palette.success.contrastText
          },
          '& .MuiAlert-icon': {
            color: theme.palette.success.contrastText
          }
        },
        standardInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.main,
          '& .MuiAlertTitle-root': {
            color: theme.palette.info.contrastText
          },
          '& .MuiAlert-icon': {
            color: theme.palette.info.contrastText
          }
        },
        standardWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.main,
          '& .MuiAlertTitle-root': {
            color: theme.palette.warning.contrastText
          },
          '& .MuiAlert-icon': {
            color: theme.palette.warning.contrastText
          }
        },
        standardError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.main,
          '& .MuiAlertTitle-root': {
            color: theme.palette.error.contrastText
          },
          '& .MuiAlert-icon': {
            color: theme.palette.error.contrastText
          }
        },
        outlinedSuccess: {
          borderColor: theme.palette.success.main,
          color: getColor(theme.palette.success.main, 0.12),
          '& .MuiAlertTitle-root': {
            color: getColor(theme.palette.success.main, 0.12)
          },
          '& .MuiAlert-icon': {
            color: getColor(theme.palette.success.main, 0.12)
          }
        },
        outlinedInfo: {
          borderColor: theme.palette.info.main,
          color: getColor(theme.palette.info.main, 0.12),
          '& .MuiAlertTitle-root': {
            color: getColor(theme.palette.info.main, 0.12)
          },
          '& .MuiAlert-icon': {
            color: getColor(theme.palette.info.main, 0.12)
          }
        },
        outlinedWarning: {
          borderColor: theme.palette.warning.main,
          color: getColor(theme.palette.warning.main, 0.12),
          '& .MuiAlertTitle-root': {
            color: getColor(theme.palette.warning.main, 0.12)
          },
          '& .MuiAlert-icon': {
            color: getColor(theme.palette.warning.main, 0.12)
          }
        },
        outlinedError: {
          borderColor: theme.palette.error.main,
          color: getColor(theme.palette.error.main, 0.12),
          '& .MuiAlertTitle-root': {
            color: getColor(theme.palette.error.main, 0.12)
          },
          '& .MuiAlert-icon': {
            color: getColor(theme.palette.error.main, 0.12)
          }
        },
        filled: {
          fontWeight: 400,
          color: theme.palette.common.white
        }
      }
    }
  }
}

export default Alert
